import Vue from 'vue'
import Router, { RouteConfig } from 'vue-router'
import AuthGuard from '@/router/auth-guard.ts'

import Dashboard from '@/views/Dashboard/index.vue'
import ClientView from '@/views/ClientView/index.vue'
import EmployeeView from '@/views/EmployeeView/index.vue'
import MyPage from '@/views/EmployeeView/MyPage.vue'
import ActionForm from '@/views/ActionForm/index.vue'
import CommunityLivingDailySummary from '@/views/CommunityLivingDailySummary.vue'
import Reports from '@/views/Reports/index.vue'
import HtmlReportView from '@/views/Reports/HtmlReportView.vue'

Vue.use(Router)

export const routerUrls = {
  clientPage: '/kliendid/',
  employeePage: '/töötajad/',
  myPage: '/mina', // FIXME All URLS should end with '/'
  addAction: '/lisa/tegevus',
  updateAction: '/muuda-tegevust/'
}

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: `${routerUrls.clientPage}:Id`,
    name: 'ClientView',
    component: ClientView
  },
  {
    path: `${routerUrls.employeePage}:Id`,
    name: 'EmployeeView',
    component: EmployeeView,
    beforeEnter: AuthGuard
  },
  {
    path: routerUrls.myPage,
    name: 'MyPage',
    component: MyPage
  },
  {
    path: routerUrls.addAction,
    name: 'AddAction',
    component: ActionForm
  },
  {
    path: `${routerUrls.updateAction}:actionId`,
    name: 'UpdateAction',
    component: ActionForm,
    props: true
  },
  {
    path: `/kogukonnas-elamine/päeva-kokkuvõte/`,
    name: 'CommunityLivingDailySummary',
    component: CommunityLivingDailySummary,
    props: true
  },
  {
    path: '/sünnipäevad',
    name: 'BirthdayView',
    component: () => import('@/views/BirthdayView.vue')
  },
  {
    path: '/aruanded',
    name: 'Reports',
    component: Reports
  },
  {
    path: '/aruanded/html/:reportCode/:formats/:paramsStr',
    name: 'HtmlReportView',
    component: HtmlReportView
  }
]
/**
 * Vue Router throws an error if navigating to the current location,
 * this stops the error from being displayed on the console.
 */
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

export default new Router({ routes })
